// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"25f96bb9","977":"bc8b1886"}[chunkId] + ".chunk.js";
};